/**
 * Автор записи из сервисов-бэкендов (`X-Actor`) — словами для человека.
 *
 * admin-api отправляет в бэкенды (контент-движок, платёжку) автора в форме
 * `admin:<uuid> <email>`; бэкенд хранит строку как есть и отдаёт её обратно в
 * полях `author` / `requestedBy` / `reviewedBy` / `computedBy` и т. п. Человеку
 * uuid и префикс ни к чему — показываем e-mail.
 *
 *   actorLabelRu('admin:7f1c… ops@example.com') -> 'ops@example.com'
 *   actorLabelRu('admin:7f1c…')                 -> 'администратор'
 *   actorLabelRu('scheduler')                   -> 'автоматически'
 *   actorLabelRu('policy:noop')                 -> 'policy:noop' (свои авторы модуль подписывает сам)
 *   actorLabelRu(null)                          -> null
 */
const ADMIN_ACTOR_RE = /^admin:(\S+)(?:\s+(.+))?$/;
export function actorLabelRu(actor) {
    const v = actor?.trim();
    if (!v)
        return null;
    if (v === 'scheduler')
        return 'автоматически';
    const m = ADMIN_ACTOR_RE.exec(v);
    if (m)
        return m[2]?.trim() || 'администратор';
    return v;
}
/** Ключ сравнения: у админа — его id (e-mail мог смениться), иначе — строка. */
function actorKey(actor) {
    const v = actor.trim();
    const m = ADMIN_ACTOR_RE.exec(v);
    return m ? `admin:${m[1]}` : v;
}
/**
 * Один и тот же человек? Например, «подтвердил: …» не нужно показывать, если
 * подтвердил тот же, кто поставил действие вручную.
 */
export function isSameActor(a, b) {
    if (!a?.trim() || !b?.trim())
        return false;
    return actorKey(a) === actorKey(b);
}
//# sourceMappingURL=actor-label.js.map